import { createContext, useContext, useState } from "react";

const TourContext = createContext();

export const useTour = () => {
  const context = useContext(TourContext);

  if (!context) {
    throw new Error("useTour must be used within TourProvider");
  }

  return context;
};

export const TourProvider = ({ children }) => {
  const [tourState, setTourState] = useState({
    run: false,
    stepIndex: 0,
    activeTour: null,
    tourKey: 0,
  });

  const startTour = (tourName) => {
    setTourState((prev) => ({
      run: true,
      stepIndex: 0,
      activeTour: tourName,
      tourKey: prev.tourKey + 1,
    }));
  };

  const stopTour = () => {
    setTourState((prev) => ({
      ...prev,
      run: false,
      stepIndex: 0,
    }));
  };

  const goToStep = (index) => {
    setTourState((prev) => ({
      ...prev,
      stepIndex: index,
    }));
  };

  return (
    <TourContext.Provider
      value={{
        tourState,
        startTour,
        stopTour,
        goToStep,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};
